import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect:'/home'
  },
  {
    path: "/home",
    name: "home",
    component: ()=>import('@/views/home.vue'),
  },
  {
    path: "/about",
    name: "about",
    component: ()=>import('@/views/about.vue'),
  },
  {
    path: "/contact",
    name: "contact",
    component: ()=>import('@/views/contact.vue'),
  },
  {
    path: "/news",
    name: "news",
    component: ()=>import('@/views/news.vue'),
  },
  {
    path: "/anli",
    name: "anli",
    component: ()=>import('@/views/anli.vue'),
  },
  {
    path: "/fuwu",
    name: "fuwu",
    component: ()=>import('@/views/fuwu.vue'),
  },
  {
    path: "/mobile/home",
    name: "mobileHome",
    component: ()=>import('@/views/mobile/home.vue'),
  },
  // {
  //   path: "/mobile/xietong",
  //   name: "mobileXietong",
  //   component: ()=>import('@/views/mobile/xietong.vue'),
  // },
  {
    path: "/mobile/news",
    name: "mobileChanping",
    component: ()=>import('@/views/mobile/news.vue'),
  },
  {
    path: "/mobile/about",
    name: "mobileAbout",
    component: ()=>import('@/views/mobile/about.vue'),
  },
  {
    path: "/mobile/fuwu",
    name: "mobileFuwu",
    component: ()=>import('@/views/mobile/fuwu.vue'),
  },
  {
    path: "/mobile/contact",
    name: "mobileContact",
    component: ()=>import('@/views/mobile/contact.vue'),
  },
  {
    path: "/mobile/anli",
    name: "mobileanli",
    component: ()=>import('@/views/mobile/anli.vue'),
  },
  // {
  //   path: "/mobile/productB",
  //   name: "mobileProductB",
  //   component: ()=>import('@/views/mobile/productB.vue'),
  // },
  // {
  //   path: "/mobile/productC",
  //   name: "mobileProductC",
  //   component: ()=>import('@/views/mobile/productC.vue'),
  // },
  // {
  //   path: "/mobile/productD",
  //   name: "mobileProductD",
  //   component: ()=>import('@/views/mobile/productD.vue'),
  // },
  // {
  //   path: "/mobile/news1",
  //   name: "mobileNews1",
  //   component: ()=>import('@/views/mobile/news1.vue'),
  // },
  // {
  //   path: "/mobile/news2",
  //   name: "mobileNews2",
  //   component: ()=>import('@/views/mobile/news2.vue'),
  // },
  // {
  //   path: "/mobile/news3",
  //   name: "mobileNews3",
  //   component: ()=>import('@/views/mobile/news3.vue'),
  // },
  // {
  //   path: "/mobile/news4",
  //   name: "mobileNews4",
  //   component: ()=>import('@/views/mobile/news4.vue'),
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
